import gql from 'graphql-tag'

export const PaymentMethodPendingFieldsFragment = gql`
  fragment PaymentMethodPendingFields on PaymentMethodPending {
    id
    familyId
    accountName
    accountLast4
    verificationType
  }
`
